/** This configures the number of "slots" shown in UI */
export const PRIORITY_EVENTS_LIMIT = 3;
export const PRIORITY_EVENT_SOUND = '/sounds/Mallet_Note1.ogg';
// export const ANOMALY_SOUND = '/sounds/Mallet_Error5.ogg';
